import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import asyncComponent from '../../util/AsyncFunc';

// import AddMeeting from './addmeeting/index'

//added to show post miinutes file upload
import AddMeeting from './addmeetingNew/index'

import MeetingList from './meetinglist/index'

//auth
import {
    userIsAuthenticatedRedir, userIsNotAuthenticatedRedir,
    userIsAuthenticated, userIsNotAuthenticated, userIsSuperAdminRedir,
    userIsBoardAdminRedir, userIsCommitteeAdminRedir, userIsCheckerAdminRedir
} from '../auth'

const AddMeetingProtected_ma = userIsCommitteeAdminRedir(AddMeeting)
const MeetingListProtected_ma = userIsCommitteeAdminRedir(MeetingList)

const Meeting = ({ match }) => (
    <div className="app-wrapper">
        <Switch>
            {/* Meeting Admin */}
            <Redirect exact from={`${match.url}/`} to={`${match.url}/meeting-list`} />
            <Route path={`${match.url}/add-meeting/:id?`} component={AddMeetingProtected_ma} />
            <Route path={`${match.url}/meeting-list/:id?`} component={MeetingListProtected_ma} />
        </Switch>
    </div>
);

export default Meeting;



// WEBPACK FOOTER //
// ./app/meetingdetails/index.js